var _title, _desc, _g;

var _excluded = ["svgRef", "title"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgIconTrash = function SvgIconTrash(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "19px",
    height: "21px",
    viewBox: "0 0 19 21",
    ref: svgRef
  }, props), title === undefined ? _title || (_title = /*#__PURE__*/React.createElement("title", null, "Icon/default/excluir")) : title ? /*#__PURE__*/React.createElement("title", null, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Icon/default/excluir",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "recycle-copy",
    transform: "translate(1.000000, 2.000000)",
    stroke: "#E50C0C",
    strokeWidth: 1.5
  }, /*#__PURE__*/React.createElement("path", {
    d: "M2,3 L15,3 L15,15 C15,16.1045695 14.1045695,17 13,17 L4,17 C2.8954305,17 2,16.1045695 2,15 L2,3 L2,3 Z",
    id: "Rectangle"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    transform: "translate(8.500000, 1.500000) scale(-1, 1) rotate(-180.000000) translate(-8.500000, -1.500000) ",
    x: 5,
    y: 0,
    width: 7,
    height: 3,
    rx: 1.5
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group-27",
    strokeLinecap: "round",
    transform: "translate(5.000000, 8.000000)"
  }, /*#__PURE__*/React.createElement("line", {
    x1: 0.205882353,
    y1: 1,
    x2: 0.205882353,
    y2: 3,
    id: "Path"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 3.5,
    y1: 0,
    x2: 3.5,
    y2: 4,
    id: "Path-Copy"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 6.79411765,
    y1: 1,
    x2: 6.79411765,
    y2: 3,
    id: "Path-Copy"
  })), /*#__PURE__*/React.createElement("line", {
    x1: 8.5,
    y1: -5,
    x2: 8.5,
    y2: 11,
    id: "Path",
    strokeLinecap: "round",
    transform: "translate(8.500000, 3.000000) rotate(90.000000) translate(-8.500000, -3.000000) "
  })))));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgIconTrash, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/icon-trash.4e20f6cd.svg";
export { ForwardRef as ReactComponent };